import React, { useEffect } from 'react';
import { Outlet, Link } from 'react-router-dom';
import { useLayout } from '../contexts/LayoutContext';

export default function ModuleLayout({ title, menuItems, children }) {
    const { setTitle, setActions } = useLayout();

    useEffect(() => {
        setTitle(title);
        setActions(menuItems || []);
        return () => {
            setTitle('');
            setActions([]);
        };
    }, [title, menuItems, setTitle, setActions]);

    return (
        <div className="h-full">
            <div className="bg-white rounded-lg shadow-lg p-6 min-h-[calc(100vh-180px)]">
                {children ? children : <Outlet />}
            </div>
        </div>
    );
}
